import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.1);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border-top-color: #32cd32;
  animation: ${spin} 1s linear infinite;
`;

const LoadingIndicator: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        background: "rgba(0, 0, 0, 0.8)",
        zIndex: 9999,
      }}
    >
      <Spinner />
    </div>
  );
};

export default LoadingIndicator;
